import { render } from "./EditNotification.vue?vue&type=template&id=886f64c4"
import script from "./EditNotification.vue?vue&type=script&lang=js"
export * from "./EditNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__